import {throwError,  Observable } from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from './config.service';
import { NotificationSettingModel } from 'app/models/notification-setting.model';
import { CustomerOptOutModel } from 'app/models/customer-opt-out.model';
import { NotificationCategoryModel } from 'app/models/notification-category.model';
@Injectable()
export class NotificationsService {


    constructor(private http: HttpClient, private config: ConfigService) {

    }

    public GetNotifications(): Observable<NotificationSettingModel> {
        return this.http.get<NotificationSettingModel>(this.config.getApiRoute('api/v3/customer-portal/notifications')).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);
    }

    public SaveNotificationSettings(model: CustomerOptOutModel): Observable<Array<NotificationSettingModel>> {
        return this.http.put<Array<NotificationSettingModel>>(this.config.getApiRoute('api/v3/customer-portal/notifications/' + model.id), model).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse) => {
                return throwError(err.error.message);
            }));
    }

    public OptOutOfAll(model: NotificationCategoryModel): Observable<Array<NotificationSettingModel>> {
        return this.http.put<Array<NotificationSettingModel>>(this.config.getApiRoute('api/v3/customer-portal/notifications/opt-out-of-all/' + model.id), model).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse) => {
                return throwError(err.error.message);
            }));
    }
}
